export const formatProductData = (product: { code: string; price: { currencyIso: string; value: number } }) => ({
  id: product.code,
  price: {
    currencyIso: product.price.currencyIso,
    numericalPrice: product.price.value,
  },
});
